// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_Billing360CreditsRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_Billing360CreditsRow — ai_credit_wallets summary for the
 * billing-360 credits slot.
 *
 * balance_micro and reserved_micro are raw micro-credit integers.
 * The frontend (A-track's chip) is the sole humanisation surface; this
 * contract intentionally keeps the field names explicit *_micro so any
 * caller knows they are not human-ready cents.
 */
import { registerContract } from './validate'

export interface Subscriptions_Billing360CreditsRow {
balance_micro?: number
reserved_micro?: number
}

registerContract('Subscriptions_Billing360CreditsRow', {
  balance_micro:  { type: 'number',  required: false },
  reserved_micro: { type: 'number',  required: false },
})
